import { Link } from "react-router-dom";
import { channels } from "@/mocks/movies";

export default function CategoryShortcuts() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
      {channels.map((c) => (
        <Link
          key={c.type}
          to={`/category/${c.type}`}
          className="group flex flex-col items-start gap-2 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50"
        >
          <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50">
            <i className={`${c.icon} text-2xl`} />
          </span>
          <h3 className="font-heading text-base font-semibold text-foreground-950">{c.type}</h3>
          <p className="text-xs leading-relaxed text-foreground-500">{c.desc}</p>
        </Link>
      ))}
    </div>
  );
}